import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';

const columns = [{ id: 'extension', label: '확장자', minWidth: 40, align: 'center' }];

export default function ExtensionAuto() {
  const [datas, setDatas] = useState({});
  const [rows, setRows] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const handleRowClick = async (row) => {
    if (window.confirm('확장자를 삭제하시겠습니까?')) {
      await axios
        .delete(`/api/didas/extension/${row.id}`, { params: row })
        .then(async (response) => {
          alert(response.data.message);
          await getDataList();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const getDataList = async (e) => {
    await axios.get(`/api/didas/extension`).then((response) => {
      if (response.data.extList) {
        setRows(response.data.autoList);
      }
    });
  };

  const onClickInit = (evt) => {
    initForm();
  };

  const initForm = () => {
    setDatas({});
    clearErrors();
    reset();
  };

  const onSubmit = async (data) => {
    if (isDirty) {
      const params = { extension: data.datas.extension, name: 'auto' };
      await axios
        .post(`/api/didas/extension`, params)
        .then(async (response) => {
          alert(response.data.message);
          getDataList();
          initForm();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  useEffect(() => {
    getDataList();
  }, []);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        예외
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={() => handleRowClick(row)}>
                    {columns.map((col, colIdx) => {
                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {row[col.id]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={3}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" onClick={onClickInit}>
              초기화
            </Button>
            <Button variant="contained" type="submit" form="ExtensionAutoForm" disabled={isDirty && JSON.stringify(datas) !== '{}' ? false : true}>
              등록
            </Button>
          </Stack>
          <Box id="ExtensionAutoForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
            <TextField
              margin="dense"
              required
              fullWidth
              name="extension"
              label="확장자"
              id="extension"
              value={datas?.extension || ''}
              error={!!errors.datas?.extension}
              helperText={errors.datas?.extension && errors.datas?.extension.message}
              {...register('datas.extension', {
                required: '확장자를 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
